// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper___kqIt","info":"UpdateTermsInfo_info__inDAb"};